import Rails from "@rails/ujs"

// Custom Turbo confirmation dialog
Turbo.setConfirmMethod((message, element) => {
  // Fallback for layouts that don't include the Bootstrap modal markup.
  // Without this, a confirm can block submissions forever (no network request).
  if (typeof window === "undefined") return Promise.resolve(true);
  if (typeof $ !== "function") return Promise.resolve(window.confirm(message));

  let $element = $(element);

  let $dialog = $('#modal-confirmation')
  if ($dialog.length === 0 || typeof $dialog.modal !== "function") {
    return Promise.resolve(window.confirm(message));
  }

  let $msg = $dialog.find('#modal-conf-msg')
  let $ok = $dialog.find('#modal-ok-btn')
  let $cancel = $dialog.find('#modal-cancel-btn')

  $dialog.find('#modal-cancel-btn').text($element.data('cancel') || 'Cancel')

  $msg.text(message)

  if ($element.data('method') == 'delete') {
    $('#modal-confirm-delete-icon').show();
    $ok.text($element.data('ok') || 'DELETE');
    if ($element.data('ok') == 'Yes') {
      $ok.removeClass('btn-danger').addClass('btn-primary');
    }
  } else {
    $('#modal-confirm-delete-icon').hide();
    $ok.text($element.data('ok') || 'YES')
      .removeClass('btn-danger').addClass('btn-primary');
  }

  if ($element.data('cancel-only')) {
    $ok.hide()
  } else {
    $ok.show()
  }

  $dialog.modal("show")

  return new Promise((resolve) => {
    let settled = false;
    const settle = (value) => {
      if (settled) return;
      settled = true;
      resolve(value);
    };

    $ok.one('click', function (event) {
      event.preventDefault()
      settle(true)
      $dialog.modal("hide")
    });

    $cancel.one('click', function (event) {
      event.preventDefault()
      settle(false)
      $dialog.modal("hide")
    });

    // If the modal is dismissed by other means (ESC/backdrop), treat as cancel.
    $dialog.one('hidden.bs.modal', function () {
      settle(false)
    });
  });
})

// Custom Rails confirmation dialog
Rails.confirm = function (message, element, callback) {
  // Fallback for layouts that don't include the Bootstrap modal markup.
  if (typeof window !== "undefined" && (typeof $ !== "function" || $('#modal-confirmation').length === 0 || typeof $('#modal-confirmation').modal !== "function")) {
    const ok = window.confirm(message);
    if (ok && typeof callback === "function") callback();
    return ok;
  }

  if (!element) {
    element = document.createElement('a')
  }

  let $element = $(element);

  $('.modal-confirm-cloned-element').empty()
  // Fix: copy element to dom. it allow click on deleted element.
  // it's happens when click on an element inside a tooltip(calendar, map)
  if ($element.data('confirm-clone')) {
    $('.modal-confirm-cloned-element').empty().append(element.cloneNode())
    $element = $($('.modal-confirm-cloned-element').children()[0]);
  }


  let $dialog = $('#modal-confirmation')
  let $msg = $dialog.find('#modal-conf-msg')
  let $ok = $dialog.find('#modal-ok-btn')

  $dialog.find('#modal-cancel-btn').text($element.data('cancel') || 'Cancel')

  $msg.text(message)

  if ($element.data('method') == 'delete') {
    $('#modal-confirm-delete-icon').show();
    $ok.text($element.data('ok') || 'DELETE');
    if ($element.data('ok') == 'Yes') {
      $ok.removeClass('btn-danger').addClass('btn-primary');
    }
  } else {
    $('#modal-confirm-delete-icon').hide();
    $ok.text($element.data('ok') || 'YES')
      .removeClass('btn-danger').addClass('btn-primary');
  }

  if ($element.data('cancel-only')) {
    $ok.hide()
  } else {
    $ok.show()
  }

  // remove previous click events
  $ok.off('click')

  $ok.one('click', function (event) {
    event.preventDefault()
    let old = Rails.confirm
    Rails.confirm = function () { return true }

    if (callback) {
      callback()
    } else {
      $element.get(0).click()
    }

    Rails.confirm = old
    $dialog.modal("hide")
  });

  $dialog.modal("show")
  return false;
}
